module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 71300.f665ebfa.png";